import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('planejamento_acao', 'cadastro');

const planejamentoAcaoActions = {
  salvarAcao: { method: 'POST', url: `${basePath}` },
  atualizarAcao: { method: 'PUT', url: `${basePath}` },
  buscarTiposAcao: { method: 'GET', url: `${basePath}/campos/tipo_acao` },
  buscarHoldings: { method: 'GET', url: `${basePath}/campos/holding` },
  buscarClientes: { method: 'GET', url: `${basePath}/campos/cliente` },
  buscarDivisoes: { method: 'GET', url: `${basePath}/campos/divisao` },
  buscarUnidadesNegocioDivisao: { method: 'GET', url: `${basePath}/campos/divisao/{idDivisao}/unidade_negocio` },
  buscarClientesPagadores: { method: 'GET', url: `${basePath}/campos/cliente/pagador` },
  buscarPeriodos: { method: 'GET', url: `${basePath}/campos/periodo` },
  buscarContasCorrentesElegiveis: { method: 'GET', url: `${basePath}/conta_corrente/elegiveis{?id_produto*}` },
  executarAnalise: { method: 'PUT', url: `${basePath}/{idAcao}/executarAnalise` },
};

export default resource => resource(`${basePath}`, {}, planejamentoAcaoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/planejamento-acao-cadastro.js